export var IListOrdersByBrandOrderResponse;
(function (IListOrdersByBrandOrderResponse) {
    let RetailerIdvStatus;
    (function (RetailerIdvStatus) {
        /**
         * Unknown status.
         */
        RetailerIdvStatus["RETAILER_IDV_STATUS_UNKNOWN"] = "RETAILER_IDV_STATUS_UNKNOWN";
        /**
         * The retailer has never received any IDV request.
         */
        RetailerIdvStatus["NEVER_RECEIVED_IDV"] = "NEVER_RECEIVED_IDV";
        /**
         * There is an pending IDV request waiting for the retailer's response.
         */
        RetailerIdvStatus["HAS_PENDING_IDV_REQUEST"] = "HAS_PENDING_IDV_REQUEST";
        /**
         * The retailer has responded all IDV requests.
         */
        RetailerIdvStatus["IDV_REQUEST_RESPONDED"] = "IDV_REQUEST_RESPONDED";
    })(RetailerIdvStatus = IListOrdersByBrandOrderResponse.RetailerIdvStatus || (IListOrdersByBrandOrderResponse.RetailerIdvStatus = {}));
    let IBrandOrderData;
    (function (IBrandOrderData) {
        let IBrandData;
        (function (IBrandData) {
            /**
             * Return an instance of IBrandData with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IBrandData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IBrandData = IBrandOrderData.IBrandData || (IBrandOrderData.IBrandData = {}));
        let IItemData;
        (function (IItemData) {
            /**
             * Return an instance of IItemData with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IItemData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IItemData = IBrandOrderData.IItemData || (IBrandOrderData.IItemData = {}));
        let IBrandReviewData;
        (function (IBrandReviewData) {
            /**
             * Return an instance of IBrandReviewData with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IBrandReviewData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IBrandReviewData = IBrandOrderData.IBrandReviewData || (IBrandOrderData.IBrandReviewData = {}));
        let IEligibility;
        (function (IEligibility) {
            let Enum;
            (function (Enum) {
                /**
                 * Should not be used.
                 * TODO(noah): change this to UNKNOWN once Faire/backend#58586 lands before we launch
                 */
                Enum["ENUM_UNKNOWN"] = "ENUM_UNKNOWN";
                /**
                 * Not eligible for this action
                 */
                Enum["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
                /**
                 * Eligible for this action without any issues
                 */
                Enum["ELIGIBLE"] = "ELIGIBLE";
                /**
                 * Requires someone to review and process the eligibility of this action
                 */
                Enum["MANUAL_PROCESS_REQUIRED"] = "MANUAL_PROCESS_REQUIRED";
            })(Enum = IEligibility.Enum || (IEligibility.Enum = {}));
            /**
             * Return an instance of IEligibility with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IEligibility.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IEligibility = IBrandOrderData.IEligibility || (IBrandOrderData.IEligibility = {}));
        let IShipmentData;
        (function (IShipmentData) {
            let IShipmentStatus;
            (function (IShipmentStatus) {
                /**
                 * Return an instance of IShipmentStatus with the provided fields. Any field not
                 * listed will be populated with an empty value (an empty array,
                 * or undefined, whichever is valid for the type of the value.)
                 */
                IShipmentStatus.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
            })(IShipmentStatus = IShipmentData.IShipmentStatus || (IShipmentData.IShipmentStatus = {}));
            /**
             * Return an instance of IShipmentData with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IShipmentData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IShipmentData = IBrandOrderData.IShipmentData || (IBrandOrderData.IShipmentData = {}));
        /**
         * Return an instance of IBrandOrderData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IBrandOrderData.build = (partial) => (Object.assign({ items: [], shipment_data: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IBrandOrderData = IListOrdersByBrandOrderResponse.IBrandOrderData || (IListOrdersByBrandOrderResponse.IBrandOrderData = {}));
    /**
     * Return an instance of IListOrdersByBrandOrderResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IListOrdersByBrandOrderResponse.build = (partial) => (Object.assign({ filter_sections: [], orders: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IListOrdersByBrandOrderResponse || (IListOrdersByBrandOrderResponse = {}));
